import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Risorsa } from '../interfaces/risorse.interface';
import { FiltroElencoRisorse } from '../interfaces/filtro-elenco-risorse.interface';
import { Observable } from 'rxjs';
import { tipologicaInterface } from '../interfaces/tipologica.interface';

@Injectable({
  providedIn: 'root',
})
export class ElencoRisorseService {
  constructor(private readonly http: HttpClient) {}

  private _risorsa: Risorsa = {};
  set risorsa(value: Risorsa) {
    this._risorsa = value;
  }
  get risorsa(): Risorsa {
    return this._risorsa;
  }

  private _commesse: tipologicaInterface[] = [];
  set commesse(value: tipologicaInterface[]) {
    this._commesse = value;
  }
  get commesse(): tipologicaInterface[] {
    return this._commesse;
  }

  private _uoPrimoLivello: tipologicaInterface[] = [];
  set uoPrimoLivello(value: tipologicaInterface[]) {
    this._uoPrimoLivello = value;
  }
  get uoPrimoLivello(): tipologicaInterface[] {
    return this._uoPrimoLivello;
  }

  baseUrl = 'api/TimeSheetRev';

  elencoRisorse(filter: FiltroElencoRisorse): Observable<any> {
    const responseType = filter.flagExport ? 'blob' : 'json';
    return this.http.post<any>(
      this.baseUrl + '/risorse/ricerca',
      filter,
      {
        responseType: responseType as 'json',
      }
    );
  }

  elencoRisorseCount(filter: FiltroElencoRisorse): Observable<any> {
    return this.http.post(
      this.baseUrl + '/risorse/ricerca/count',
      filter
    );
  }

  approvaRisorsa(risorseList: Risorsa[]): Observable<any> {
    return this.http.patch(
      this.baseUrl + '/approvazione/risorse',
      { risorse: risorseList }
    );
  }

  approvazioneMassiva(): Observable<any> {
    return this.http.patch(
      this.baseUrl + '/approvazione/massiva', null
    )
  }

  conteggioCoincidenze(): Observable<any> {
    return this.http.get(this.baseUrl + '/conteggioCoincidenze');
  }

  timesheetApprovati(): Observable<any> {
    return this.http.get(this.baseUrl + '/allTimesheetApprovati');
  }
}
